import { useRequest } from 'ahooks'
import { Skeleton } from 'antd'
import { createStyles } from 'antd-style'

import { queryHelpDocApi } from '@eastcoal/api/content/helpDocMall/queryHelpDoc'

import { DataError } from '@eastcoal/common/components/DataError'

import { RichEditor } from '@eastcoal/editor/index'

import { useHomeStore } from '../../Store/hooks/useStore'

const useStyles = createStyles(({ token }) => ({
  richEditor: {
    paddingBlock: token.paddingSM
  }
}))

export const DocContent = () => {
  const id = useHomeStore(state => state.currentDocId)

  const { data, error, loading, refreshAsync } = useRequest(
    () => queryHelpDocApi({ id }),
    {
      manual: false,
      ready: !!id,
      refreshDeps: [id]
    }
  )

  const { styles } = useStyles()

  return (
    <Skeleton active loading={loading} paragraph={{ rows: 5 }}>
      {error ? (
        <DataError block error={error} reload={refreshAsync} />
      ) : (
        <RichEditor
          readPretty
          className={styles.richEditor}
          value={data?.content}
        />
      )}
    </Skeleton>
  )
}
